const styles = {
  wrap: {
    width: '100%',
  },
  label: {
    fontSize: 14,
    fontFamily: "'Proxima Nova', 'Open Sans', 'Montserrat', sans-serif",
  },
  input: {
    width: '100%',
    '& input': {
      border: '1px solid #E2E2FC',
      borderRadius: 8,
      padding: '0 12px',
      backgroundColor: '#FFFFFF',
      width: '100%',
      height: 40,
      fontFamily: "'Proxima Nova', 'Open Sans', 'Montserrat', sans-serif",
      '&::-webkit-input-placeholder ': {
        color: '#707087',
        fontFamily: "'Proxima Nova', 'Open Sans', 'Montserrat', sans-serif",
        opacity: 1,
      },
      '&:-ms-input-placeholder': {
        color: '#707087',
        fontFamily: "'Proxima Nova', 'Open Sans', 'Montserrat', sans-serif",
        opacity: 1,
      },
      '&::placeholder': {
        color: '#707087',
        fontFamily: "'Proxima Nova', 'Open Sans', 'Montserrat', sans-serif",
        opacity: 1,
      },
    },
  },
  error: {
    fontSize: 12,
    color: '#FF0000',
    marginBottom: 1,
  },
  emptyMargin: {
    height: 16,
  },
}
export { styles }
